<template>
  <nx-dialog
    :value="active"
    icon="check_circle"
    :title="$t('message.searcher.bulk.confirmSelection.title')"
    @input="close"
  >
    <ds-text
      size="500"
      v-html="description"
    />
    <ds-text
      v-if="limitReached"
      class="mt-4"
      size="500"
      v-html="limitReachedText"
    />
    <nx-list
      v-if="selectedItems.length > 0 && !useSearchConfig"
      class="mt-4"
      open-in-new-tab
      :items="selectedItems"
      condensed
    />
    <template slot="actions">
      <v-btn
        color="secondary"
        flat
        @click="close"
      >
        {{ $t('message.common.cancel') }}
      </v-btn>
      <v-btn
        color="secondary"
        flat
        @click="accept"
      >
        {{ $t('message.common.continue') }}
      </v-btn>
    </template>
  </nx-dialog>
</template>

<script>
import NxDialog from '@/components/dialogs/Dialog.vue';
import NxList from '@/components/list/List.vue';

export default {
  name: 'NxSearcherSelectionConfirmDialog',
  components: { NxList, NxDialog },
  props: {
    totalItems: {
      type: Number,
      default: 0,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
    useSearchConfig: {
      type: Boolean,
    },
  },
  data() {
    return {
      action: null,
      active: false,
    };
  },
  computed: {
    limit() {
      if (!this.action) {
        return null;
      }
      return this.action.limit || null;
    },
    limitReached() {
      if (!this.limit) {
        return false;
      }
      return this.totalItems > this.limit;
    },
    description() {
      if (this.useSearchConfig && !this.limitReached) {
        return this.$t('message.searcher.bulk.confirmSelection.useSearchConfigMessage', { numResults: this.totalItems, url: this.$route.fullPath });
      }
      return this.$tc('message.searcher.bulk.confirmSelection.message', this.selectedItems.length, { numResults: this.selectedItems.length });
    },
    limitReachedText() {
      return this.$t('message.searcher.bulk.confirmSelection.limitMessage', { limit: this.limit });
    },
  },
  methods: {
    open(action) {
      this.action = action;
      this.active = true;
    },
    close() {
      this.action = null;
      this.active = false;
    },
    accept() {
      this.$emit('continue', this.action);
      this.close();
    },
  },
};
</script>
